export const sxStyle = {
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: { xs: 'column', sm: 'row' }, // responsive
  },

  destinationContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginTop: { xs: '8px', sm: 0 }, // responsive
  },

  planeButton: {
    '&:hover': {
      background: 'none',
    },
  },

  planeIcon: {
    color: '#636466',
    border: '1px solid #C4C4C4',
    borderRadius: '8px',
  },
};
